if (!customElements.get('gift-card-recipient')) {
  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.recipientCheckbox = this.querySelector('.gift-card-recipient__checkbox');
      this.fields = this.querySelector('.gift-card-recipient__fields');

      this.recipientEmail = this.querySelector('[name="properties[Recipient email]"]');
      this.recipientEmailLabel = this.recipientEmail
        ? this.querySelector(`label[for="${this.recipientEmail.id}"]`)
        : null;

      this.recipientName = this.querySelector('[name="properties[Recipient name]"]');
      this.recipientMessage = this.querySelector('[name="properties[Message]"]');
      this.recipientSendOn = this.querySelector('[name="properties[Send on]"]');
      this.recipientOffsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');

      this.hoverIcon = this.querySelector('lord-icon.gcr-icon--hover');
      this.clickIcon = this.querySelector('lord-icon.gcr-icon--click');

      if (this.recipientEmailLabel && this.recipientEmailLabel.dataset && this.recipientEmailLabel.dataset.jsLabel) {
        this.recipientEmailLabel.innerText = this.recipientEmailLabel.dataset.jsLabel;
      }

      if (this.recipientOffsetProperty) {
        this.recipientOffsetProperty.value = new Date().getTimezoneOffset().toString();
        this.recipientOffsetProperty.removeAttribute('disabled');
      }

      if (this.recipientCheckbox) {
        this.recipientCheckbox.addEventListener('change', () => {
          this.synchronizeProperties();
          this.syncAria();
          this.playClickAnimationIfNeeded();
          this.updateActiveState();
        });
      }

      this.addEventListener('mouseenter', () => this.playHoverNudge());
      this.addEventListener('focusin', () => this.playHoverNudge());

      this.synchronizeProperties();
      this.syncAria();
      this.updateActiveState();
    }

    syncAria() {
      if (!this.fields || !this.recipientCheckbox) return;
      this.fields.setAttribute('aria-hidden', this.recipientCheckbox.checked ? 'false' : 'true');
    }

    synchronizeProperties() {
      if (!this.recipientCheckbox) return;

      if (this.recipientCheckbox.checked) {
        if (this.recipientEmail) {
          this.recipientEmail.setAttribute('required', '');
          this.recipientEmail.removeAttribute('disabled');
        }
        if (this.recipientName) this.recipientName.removeAttribute('disabled');
        if (this.recipientMessage) this.recipientMessage.removeAttribute('disabled');
        if (this.recipientSendOn) this.recipientSendOn.removeAttribute('disabled');
        if (this.recipientOffsetProperty) this.recipientOffsetProperty.removeAttribute('disabled');
      } else {
        if (this.recipientEmail) {
          this.recipientEmail.removeAttribute('required');
          this.recipientEmail.setAttribute('disabled', '');
        }
        if (this.recipientName) this.recipientName.setAttribute('disabled', '');
        if (this.recipientMessage) this.recipientMessage.setAttribute('disabled', '');
        if (this.recipientSendOn) this.recipientSendOn.setAttribute('disabled', '');
        if (this.recipientOffsetProperty) this.recipientOffsetProperty.setAttribute('disabled', '');
      }
    }

    playHoverNudge() {
      if (!this.recipientCheckbox || this.recipientCheckbox.checked) return;

      try {
        const icon = this.hoverIcon;
        if (!icon) return;

        const player =
          icon.playerInstance ||
          icon.player ||
          (typeof icon.getPlayer === 'function' ? icon.getPlayer() : null);

        if (player && typeof player.playFromBeginning === 'function') {
          player.playFromBeginning();
        } else if (player && typeof player.playFromStart === 'function') {
          player.playFromStart();
        } else if (typeof icon.playFromBeginning === 'function') {
          icon.playFromBeginning();
        }
      } catch (e) {}
    }

    playClickAnimationIfNeeded() {
      if (!this.recipientCheckbox || !this.recipientCheckbox.checked) return;

      try {
        const icon = this.clickIcon;
        if (!icon) return;

        const player =
          icon.playerInstance ||
          icon.player ||
          (typeof icon.getPlayer === 'function' ? icon.getPlayer() : null);

        if (player && typeof player.playFromBeginning === 'function') {
          player.playFromBeginning();
        } else if (player && typeof player.playFromStart === 'function') {
          player.playFromStart();
        } else if (typeof icon.playFromBeginning === 'function') {
          icon.playFromBeginning();
        }
      } catch (e) {}
    }

    /* New: toggle active class so panel shows as active when open */
    updateActiveState() {
      if (!this.recipientCheckbox) return;
      this.classList.toggle(
        'gift-card-recipient--active',
        this.recipientCheckbox.checked
      );
    }
  }

  customElements.define('gift-card-recipient', GiftCardRecipient);
}